import React from 'react';
import styles from '../../assets/styles/Onboarding/Onboarding.module.scss';
import OTPForm from './OTPForm';
import OnboardLeft from '../Onboarding/OnboardLeft';

const OTP = ({ onSubmit, resendCode, setOTP, loading }) => {
	return (
		<div className={styles.container}>
			<OnboardLeft
				crumbs1={styles.crumbs__active}
				crumbs2={styles.crumbs__default}
				crumbs3={styles.crumbs__default}
			/>
			<div className={styles.right}>
				{!loading ? (
					<>
						<p className={styles.text__center}>
							To make sure we’ve got your details right,
							<br />
							we’ve sent a 5 digit code to your registered email
						</p>
						<p
							className={`${styles.text__bold} ${styles.text__color__primary}`}>
							Please enter the code below
						</p>{' '}
					</>
				) : (
					''
				)}
				<OTPForm
					onSubmit={onSubmit}
					resendCode={resendCode}
					setOTP={setOTP}
					loading={loading}
				/>
				<p className={styles.text__small}>
					Didn’t get any code?{' '}
					<span
						className={`${styles.text__bold} ${styles.text__clickable} ${styles.mt_30}`}
						onClick={resendCode}>
						Resend Code
					</span>{' '}
				</p>
			</div>
		</div>
	);
};

export default OTP;
